import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CoreDirectivesModule } from '@directives/_core/_core.directives.module';
import { LayoutDirectivesModule } from '@directives/_layout/_layout.directives.module';
import { MiscDirectivesModule } from '@directives/_misc/_misc.directives.module';
import { ResourceFiltersDirectivesModule } from '@directives/_resourceFilters/_resourceFilters.directives.module';
import { TranslationDirectivesModule } from '@directives/_translations/_translations.directives.module';
import { VeriDirectivesModule } from '@directives/_veri/_veri.directives.module';
import { UserAccessTesterComponent } from './permissions/user-access-tester/user-access-tester.component';


const privateComponents: Type<any>[] = [

];

const publicComponents: Type<any>[] = [
    UserAccessTesterComponent
];

@NgModule({
    providers: [],
    imports: [
        CommonModule,
        VeriDirectivesModule,
        TranslationDirectivesModule,
        MiscDirectivesModule,
        CoreDirectivesModule,
        LayoutDirectivesModule,
        ResourceFiltersDirectivesModule
    ],
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents],
    exports: [...publicComponents],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DiagnosticsModule {
}
